import { getMarketsMarketIdVerticalsVerticalIdSettingsGeneral } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { useQuery } from "@tanstack/react-query";

export const getGeneralSetupQueryKey = (
	marketId: number,
	verticalId: number,
) => {
	return ["GENERAL_SETUP", marketId, verticalId];
};

export function useGeneralSetupQuery(marketId: number, verticalId: number) {
	return useQuery({
		queryKey: getGeneralSetupQueryKey(marketId, verticalId),
		queryFn: processResponse(() =>
			getMarketsMarketIdVerticalsVerticalIdSettingsGeneral(
				marketId,
				verticalId,
			),
		),
		retry: false,
		refetchInterval: false,
		refetchIntervalInBackground: false,
		enabled: !!marketId && !!verticalId,
	});
}
